export const sidebarActions = [
  {
    label: 'Dummies',
    icon: 'person',
    url: '/dummies/'
  }
];
